import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { connect } from "./redux/blockchain/blockchainActions";
import { fetchData } from "./redux/data/dataActions";
import * as s from "./styles/globalStyles";
import styled from "styled-components";
import YoutubeBackground from 'react-youtube-background';

const truncate = (input, len) =>
  input.length > len ? `${input.substring(0, len)}...` : input;

export const StyledButton = styled.button`
  padding: 10px;
  border-radius: 5px;
  border: none;
  background-color: lightseagreen;
  padding: 10px;
  //font-weight: bold;
  font-family: inherit;
  font-size: 20px;
  color: var(--primary-text);
  width: 120px;
  cursor: pointer;
  border-radius: 4px;
  transition-duration: 0.4s;
  box-shadow: 0px 0px 0px 0px gray;
  :hover {
  background: var(--accent);  
  }
  :active {
    background: var(--accent); 
    box-shadow: 0px 2px 10px 5px gray;
  }
`;

export const StyledRoundButton = styled.button`
  padding: 10px;
  border-radius: 100%;
  border: none;
  background-color: #547d9a;
  padding: 10px;
  font-weight: bold;
  font-size: 15px;
  color: var(--primary-text);
  width: 30px;
  height: 30px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition-duration: 0.4s;
  box-shadow: 0px 0px 0px 0px gray;
  :hover {
  background: deepskyblue;  
  
  }
  :active {
    background: deepskyblue; 
    box-shadow: 0px 2px 10px 5px gray;
  }
`;

export const ResponsiveWrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: stretched;
  align-items: stretched;
  width: 100%;
  @media (min-width: 1000px) {
    flex-direction: row;
  }
`;

export const Wrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: stretched;
  align-items: stretched;
  width: 100%;   
`;

export const StyledLogo = styled.img`
  width: 200px;  
  @media (min-width: 767px) {
    width: 300px;
  }
  transition: width 0.5s;
  transition: height 0.5s;
`;

export const StyledImg = styled.img`
  //box-shadow: 0px 5px 11px 2px rgba(0, 0, 0, .5);
  //border: 4px hidden var(--secondary);
  //background-color: var(--accent);
  border-radius: 10%;
  width: 200px;
  @media (min-width: 400px) {
    width: 250px;
  }
  
  transition: width 0.5s;  
`;

export const StyledLink = styled.a`
  color: var(--secondary);
  atext-decoration: none;
`;

export const SocialLink = styled.a`
  
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
  -webkit-animation-timing-function: ease-in-out;
  animation-timing-function: ease-in-out;
  animation-iteration-count: infinite;
  -webkit-animation-iteration-count: infinite;
  :hover {
    cursor: pointer;
    animation-name: bounce;
    -moz-animation-name: bounce;
  }
  :active {    
    cursor: pointer;
    animation-name: bounce;
    -moz-animation-name: bounce;
  }
`;

export const NFTContainer = styled.div`
    width:100%;

    @media (min-width: 460px) {
    width:400px;
    }    
  
`;

export const StyledTitle = styled.div`


	font-weight: normal;

	font-family: 'Anton', sans-serif;

	font-size:46px;

	line-height: 0.9;
    	
	font-weight: normal;	

	xtop: -10px;

	xleft: -1%;

	padding: 0px 20px 0px 30px;

	max-width: 480px;

	xheight: 140px;

	position: relative;

	text-transform: uppercase;	

	-webkit-transform: rotate(356deg);

	-moz-transform: rotate(356deg);

	-o-transform: rotate(356deg);

    animation: showUpRot 10s ease-in-out infinite;
`;

export const Title0 = styled.div`

color:var(--yellow-text); 
font-size:46px; 
line-height: 0.9;
text-shadow: 4px 4px 8px #000000;
text-align: center;

`;

export const Title1 = styled.div`
font-size:27px;
float: left;
line-height: 40px;

`;

export const Title2 = styled.div`
font-size:37px; 
padding-top: 10px; 
float: right;

`;

function App() {
  const dispatch = useDispatch();
  const blockchain = useSelector((state) => state.blockchain);
  const data = useSelector((state) => state.data);
  const [claimingNft, setClaimingNft] = useState(false);
  const [feedback, setFeedback] = useState(`Click buy to mint your NFT.`);
  const [mintAmount, setMintAmount] = useState(1);
  const [CONFIG, SET_CONFIG] = useState({
    CONTRACT_ADDRESS: "",
    SCAN_LINK: "",
    NETWORK: {
      NAME: "",
      SYMBOL: "",
      ID: 0,
    },
    NFT_NAME: "",
    SYMBOL: "",
    MAX_SUPPLY: 1,
    WEI_COST: 0,
    DISPLAY_COST: 0,
    GAS_LIMIT: 0,
    MARKETPLACE: "",
    MARKETPLACE_LINK: "",
    SHOW_BACKGROUND: false,
  });

  const claimNFTs = () => {
    let cost = CONFIG.WEI_COST;
    let gasLimit = CONFIG.GAS_LIMIT;
    let totalCostWei = String(cost * mintAmount);
    let totalGasLimit = String(gasLimit * mintAmount);
    console.log("Cost: ", totalCostWei);
    console.log("Gas limit: ", totalGasLimit);
    setFeedback(`Minting your ${CONFIG.NFT_NAME}...`);
    setClaimingNft(true);
    blockchain.smartContract.methods
      .mint(mintAmount)
      .send({
        gasLimit: String(totalGasLimit),
        to: CONFIG.CONTRACT_ADDRESS,
        from: blockchain.account,
        value: totalCostWei,
      })
      .once("error", (err) => {
        console.log(err);
        setFeedback("Sorry, something went wrong please try again later.");
        setClaimingNft(false);
      })
      .then((receipt) => {
        console.log(receipt);
        setFeedback(
          `WOW, the ${CONFIG.NFT_NAME} is yours! go visit Opensea.io to view it.`
        );
        setClaimingNft(false);
        dispatch(fetchData(blockchain.account));
      });
  };

  const decrementMintAmount = () => {
    let newMintAmount = mintAmount - 1;
    if (newMintAmount < 1) {
      newMintAmount = 1;
    }
    setMintAmount(newMintAmount);
  };

  const incrementMintAmount = () => {
    let newMintAmount = mintAmount + 1;
    if (newMintAmount > 10) {
      newMintAmount = 10;
    }
    setMintAmount(newMintAmount);
  };

  const getData = () => {
    if (blockchain.account !== "" && blockchain.smartContract !== null) {
      dispatch(fetchData(blockchain.account));
    }
  };

  const getConfig = async () => {
    const configResponse = await fetch("./config/config.json", {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });
    const config = await configResponse.json();
    SET_CONFIG(config);    
  };

  useEffect(() => {
    getConfig();
  }, []);

  useEffect(() => {
    getData();
  }, [blockchain.account]);

  return (      
    <s.Screen>
    
    <YoutubeBackground videoId={"RAS-rBGzW24"}playerOptions={{loop:1,controls:0,showinfo:0,iv_load_policy:3}}overlay={"rgba(0,0,0,.2)"} style={{"z-index":"100"}}>
      <s.Container
        flex={1}
        ai={"center"}
        style={{ spadding: 24, "min-height": "100vh"}}
        image={CONFIG.SHOW_BACKGROUND ? "./config/images/bg_main.jpg" : null}
          
      >
      
         <s.Container flex={.2} jc={"center"} ai={"center"} style={{ padding: 20}}>
            <StyledTitle>
                <Title0>
                    <Title1>
                        The unique
                    </Title1><br></br>
                    Mutant <font color="#fe2222">Fighting</font> Cup                  
                    <Title2>
                        NFT Collection
                    </Title2>
                </Title0>
            </StyledTitle>


         </s.Container>
        
        
        <Wrapper flex={1}  style={{ padding: 24 }} test>
          
         
          <NFTContainer
            flex={1}
            jc={"center"}
            ai={"center"}
            style={{
              
              "background": "rgba(2,0,36,.15)",
              "background": "linear-gradient(0deg, rgba(2,0,36,.15) 0%, rgba(9,9,121,.15) 35%, rgba(0,212,255,.15) 100%)",

              //backgroundColor: "rgba(0,0,0,0.15)",
              padding: 24,
              //borderRadius: 24,
              border: "4px inset var(--accent-text)",
              //boxShadow: "0px 5px 11px 2px rgba(0,0,0,.5)",
              "margin-left":"auto",
              "margin-right":"auto",
              //"background-image": "url('/config/images/big_green_bg.png')",   
              //"background-repeat": "no-repeat",
              //"background-size": "contain"
              "backdrop-filter": "blur(10px) brightness(.5)"              
            }}
          >
          <s.Container flex={1} jc={"center"} ai={"center"} style={{"animation": "showUp 1s ease-in-out", "animation-delay":".25s",
          
            //"background-image": "url('/config/images/mfc2_big_icon.png')",
            //"background-repeat": "no-repeat",
            //"background-size": "contain"
          
          }} >
            
            <StyledImg alt={"example"} src={"./config/images/preview.gif"} style={{
            //"width": "200px", "padding-bottom": "17px"
            "border-radius": "20%"
            }} />
            <StyledImg alt={"example"} src={"./config/images/card1.png"} style={{
            "position":"absolute",
            "border-radius": "0%",
            "boxShadow":"none"
            }} />
            
            
          </s.Container>
            {data.totalSupply != 0 ? 
            (
            <s.TextTitle
              style={{
                textAlign: "center",
                fontSize: 35,
                fontWeight: "bold",
                color: "var(--primary-text)",
              }}
            >            
              {data.totalSupply} / {CONFIG.MAX_SUPPLY}
            </s.TextTitle>
            ):(<s.SpacerSmall />)}

            <s.TextDescription
                  style={{ textAlign: "center", color: "var(--primary-text)" }}
                >
                   MFC dog collection on 
               
            <StyledLink target={"_blank"} href={CONFIG.MARKETPLACE_LINK}  style={{ "padding-left":"5px" }}>
               opensea.io
              </StyledLink>
            </s.TextDescription>
                        
            {Number(data.totalSupply) >= CONFIG.MAX_SUPPLY ? (
              <>
                <s.TextTitle
                  style={{ textAlign: "center", color: "var(--primary-text)" }}
                >
                  The sale has ended.
                </s.TextTitle>
                <s.TextDescription
                  style={{ textAlign: "center", color: "var(--primary-text)" }}
                >
                  You can still find {CONFIG.NFT_NAME} on
                </s.TextDescription>
                
                <StyledLink target={"_blank"} href={CONFIG.MARKETPLACE_LINK}>
                  {CONFIG.MARKETPLACE}
                </StyledLink>
              </>
            ) : (
              <>
                <s.TextTitle
                  style={{ textAlign: "center", color: "var(--primary-text)" }}
                >
                  1 {CONFIG.SYMBOL} costs <font color="#fdd000">{CONFIG.DISPLAY_COST}{" "}
                  {CONFIG.NETWORK.SYMBOL}</font>.
                </s.TextTitle>
                
                <s.TextDescription
                  style={{ textAlign: "center", color: "var(--primary-text)" }}
                >
                  Excluding gas fees.
                </s.TextDescription>
                <s.SpacerSmall />
                {blockchain.account === "" ||
                blockchain.smartContract === null ? (
                  <s.Container ai={"center"} jc={"center"}>
                    <s.TextDescription
                      style={{
                        textAlign: "center",
                        color: "var(--accent-text)",
                      }}
                    >
                      Connect to the {CONFIG.NETWORK.NAME} network
                    </s.TextDescription>
                    <s.SpacerSmall />
                    <StyledButton style={{"animation": "showUp 1s ease-in-out", "animation-delay":".5s"}}
                      onClick={(e) => {
                        e.preventDefault();
                        dispatch(connect());
                        getData();
                      }}
                    >
                      CONNECT
                    </StyledButton>
                                       
                    {blockchain.errorMsg !== "" ? (                       
                        <>
                        <s.SpacerSmall />
                        <s.TextDescription
                            style={{
                            textAlign: "center",
                            color: "var(--accent-text)",
                            }}
                        >
                            {blockchain.errorMsg}
                        </s.TextDescription>
                        </>                            
                    ) : null}
                    
                  </s.Container>
                ) : (
                  <>
                    <s.TextDescription
                      style={{
                        textAlign: "center",
                        color: "var(--accent-text)",
                      }}
                    >
                      {feedback}
                    </s.TextDescription>
                    <s.SpacerMedium />
                    <s.Container ai={"center"} jc={"center"} fd={"row"}>
                      <StyledRoundButton
                        style={{ lineHeight: 0.4 }}
                        disabled={claimingNft ? 1 : 0}
                        onClick={(e) => {
                          e.preventDefault();
                          decrementMintAmount();
                        }}
                      >
                        -
                      </StyledRoundButton>
                      <s.SpacerMedium />
                      <s.TextDescription
                        style={{
                          textAlign: "center",
                          color: "var(--primary-text)",
                        }}
                      >
                        {mintAmount}
                      </s.TextDescription>
                      <s.SpacerMedium />
                      <StyledRoundButton
                        disabled={claimingNft ? 1 : 0}
                        onClick={(e) => {
                          e.preventDefault();
                          incrementMintAmount();
                        }}
                      >
                        +
                      </StyledRoundButton>
                    </s.Container>
                    <s.SpacerSmall />
                    <s.Container ai={"center"} jc={"center"} fd={"row"}>
                      <StyledButton
                        disabled={claimingNft ? 1 : 0}
                        onClick={(e) => {
                          e.preventDefault();
                          claimNFTs();
                          getData();
                        }}
                      >
                        {claimingNft ? "BUSY" : "BUY"}
                      </StyledButton>
                    </s.Container>
                  </>
                )}
              </>
            )}
            <s.SpacerMedium />
          </NFTContainer>
          
        </Wrapper>
        
        <s.SpacerMedium />

        <s.Container jc={"center"} ai={"center"} style={{ padding:24}}>
          <s.TextDescription
            style={{
              textAlign: "center",
              color: "var(--gray-text)",
            }}
          >
            * Please make sure you are connected to the right network (
            {CONFIG.NETWORK.NAME} Mainnet) and the correct address. We do not own your private keys and cannot access your funds without your confirmation.
          </s.TextDescription>
          
          <s.TextDescription
            style={{
              textAlign: "center",
              color: "var(--gray-text)",
            }}
          >
            We have set the gas limit to {CONFIG.GAS_LIMIT} for the contract to
            successfully mint your NFT. We recommend that you don't lower the
            gas limit. 
          </s.TextDescription>
        </s.Container>      
      
      </s.Container>
      </YoutubeBackground> 
      <s.SpacerLarge />
      <s.SpacerLarge />
      <ResponsiveWrapper flex={1} style={{ spadding: 24, width:"80%", "margin-left": "auto", "margin-right": "auto" }} test>
          <s.Container flex={1} jc={"top"} ai={"center"} style={{ 
              "background-image": "url('./config/images/big_blue_bg.png')",   
              "background-repeat": "no-repeat",
              "background-size": "contain"}}>
            <StyledImg alt={"example"} src={"./config/images/picts02.png"} style={{"width":"90%"}}/>
            
                <s.TextTitle
                  style={{
                    textAlign: "center",
                    fontSize: 25,
                    fontWeight: "bold",
                    color: "var(--primary-text)",
                    "text-shadow": "2px 2px 4px rgba(0,0,0,.5)"
                  }}
                >
                  YOUR UNIQUE MUTANT
                </s.TextTitle>
                <s.SpacerSmall />
                <s.TextDescription
                  style={{
                    textAlign: "left",
                    color: "var(--accent-text)",
                  }}
                >
                  Each Mutant is unique and programmatically generated from over 100 possible traits, all from the Mutant Fighting Cup 2 game.<br/>
                  All Mutants are dope, but some are rarer than others.
                </s.TextDescription>
                <s.SpacerSmall />
                <s.TextDescription
                  style={{
                    textAlign: "left",
                    color: "var(--accent-text)",
                  }}
                >
                  Owning a NFT Mutant will grant you access to members-only chat with MFC devs, participating in closed alpha and beta tests, develop pools, etc. Mutantholders will need to be signed into their Metamask Wallet.
                </s.TextDescription>
          </s.Container>
          <s.SpacerLarge />
          <s.Container flex={1} jc={"top"} ai={"center"} style={{ 
              "background-image": "url('./config/images/big_red_bg.png')",   
              "background-repeat": "no-repeat",
              "background-size": "contain"}}>
            <StyledImg alt={"example"} src={"./config/images/picts04.png"} style={{"width":"90%"}}/>
            
                <s.TextTitle
                  style={{
                    textAlign: "center",
                    fontSize: 25,
                    fontWeight: "bold",
                    color: "var(--primary-text)",
                    "text-shadow": "2px 2px 4px rgba(0,0,0,.5)"
                  }}
                >
                  COLLECT AND TRADE
                </s.TextTitle>
                <s.SpacerSmall />
                <s.TextDescription
                  style={{
                    textAlign: "left",
                    color: "var(--accent-text)",
                  }}
                >
                  Since each Mutant is unique, it also has a great collectible value!<br/>
                  The Mutants are stored as ERC-721 tokens on the Ethereum blockchain and hosted on IPFS.
                  </s.TextDescription>
                <s.SpacerSmall />
                <s.TextDescription
                  style={{
                    textAlign: "left",
                    color: "var(--accent-text)",
                  }}
                >
                  Purchasing a Mutant costs 0.015 ETH. You will mint a unique, one of a kind Mutant NFT, that can be traded on <StyledLink target={"_blank"} href={CONFIG.MARKETPLACE_LINK}  style={{ "padding-left":"5px" }}>
               opensea.io
              </StyledLink>. 
                </s.TextDescription>
          </s.Container>
          <s.SpacerLarge />
          <s.Container flex={1} jc={"top"} ai={"center"}style={{ 
              "background-image": "url('./config/images/big_orange_bg.png')",   
              "background-repeat": "no-repeat",
              "background-size": "contain"}}>
            <StyledImg alt={"example"} src={"./config/images/picts01.png"} style={{"width":"90%"}}/>
          
                <s.TextTitle
                  style={{
                    textAlign: "center",
                    fontSize: 25,
                    fontWeight: "bold",
                    color: "var(--primary-text)",
                    "text-shadow": "2px 2px 4px rgba(0,0,0,.5)"
                  }}
                >
                  SUPPORT MFC3 DEVELOPMENT
                </s.TextTitle>
                <s.SpacerSmall />
                <s.TextDescription
                  style={{
                    textAlign: "left",
                    color: "var(--accent-text)",
                  }}
                >
                You can support our small team by purchasing, or minting your Mutant NFT.<br/>
                We will use the money raised to develop Mutant Fighting Cup 3 and you will get access to the closed alpha versions of the game, pools, drops and other members-only events during the development.
                </s.TextDescription>
          </s.Container>
      </ResponsiveWrapper>
      <s.SpacerLarge />
      <s.SpacerLarge />
        <s.Container jc={"center"} ai={"center"}style={{padding:20}} >
            
            <s.Container flex={1} jc={"top"} ai={"center"} style={{"flex-direction": "row","justify-content":"center"}}>
                <SocialLink target={"_blank"} href="https://www.facebook.com/mutantfightingcup"><StyledImg alt={"fb"} src={"./config/images/facebook.png"} style={{"width":"50px"}}/></SocialLink>
                <s.SpacerSmall />
                <SocialLink target={"_blank"} href="https://twitter.com/playchocolate"><StyledImg alt={"twitter"} src={"./config/images/twitter.png"} style={{"width":"50px"}}/></SocialLink>
                <s.SpacerSmall />
                <SocialLink target={"_blank"} href="https://discord.gg/8EmEUT7wSc"><StyledImg alt={"discord"} src={"./config/images/discord.png"} style={{"width":"50px"}}/></SocialLink>
                <s.SpacerSmall />
                <SocialLink target={"_blank"} href="https://playchocolate.com"><StyledImg alt={"playchocolate"} src={"./config/images/playchocolate.png"} style={{"width":"80px"}}/></SocialLink>
            </s.Container>

          <s.SpacerMedium />
          <s.TextDescription
            style={{
              textAlign: "center",
              color: "var(--gray-text)",
            }}
          >
            Copyright (c) 2022, mutantfightingcup.com
          </s.TextDescription>         
         
        </s.Container>  
       <s.SpacerLarge />
    </s.Screen>
    
  );
}

export default App;
